type RegistreLike = {
  numeroLastPacs?: string | number | null;
  ordreSection?: string | number | null;
  annee?: {
    annee?: string | number | null;
    voie?: {
      codePostal?: { commune?: { codeInsee?: string | null } | null } | null;
    } | null;
  } | null;
};

const isNil = (value: unknown): value is null | undefined =>
  value === null || value === undefined;

// Calcule le prochain numéro de PACS pour un registre donné.
// - Si le registre a déjà un dernier numéro (numeroLastPacs), celui-ci est
//   DÉJÀ le numéro complet (préfixe codeInsee + année + ordreSection inclus,
//   cf. la validation dans Assistant.tsx qui compare pacs.numero et
//   numeroLastPacs comme deux nombres complets) : on se contente de
//   l'incrémenter, sans reconstruire le préfixe par-dessus (sinon il se
//   retrouve dupliqué dans le numéro).
// - Sinon (premier PACS du registre), on construit le numéro à partir du
//   préfixe du registre + une séquence de départ.
const computeNextPacsNumber = (
  registre: RegistreLike | null | undefined,
): string | null => {
  const { numeroLastPacs } = registre ?? {};

  if (!isNil(numeroLastPacs) && numeroLastPacs !== '') {
    const lastText = String(numeroLastPacs);
    return (+lastText + 1).toString().padStart(lastText.length, '0');
  }

  const anneeRegistre = registre?.annee;
  const codeInsee = anneeRegistre?.voie?.codePostal?.commune?.codeInsee ?? '';
  const annee = anneeRegistre?.annee ?? '';
  const ordreSection = registre?.ordreSection ?? '';

  if (codeInsee === '' || annee === '') {
    return null;
  }

  return `${codeInsee}${annee}${ordreSection}00001`;
};

export default computeNextPacsNumber;
